<template>
  <div class="mainmplus">
    <div class="titlebar">
     <p><b>Total Viewers:</b> {{totalViewers}}</p>
     <p><b>Total Streamers Online:</b> {{datas.length}}</p>
    </div>
    <div class="item" v-for="broadcaster in datas" :key="broadcaster.id">
      <p>
        <span class="title">Name: </span>
        <a :href="`https://www.twitch.tv/${broadcaster.username}`">
          <span class="name">{{broadcaster.username}}</span>
        </a>
      </p>
      <p>
        <span class="title">Viewers: </span>{{broadcaster.view_count}}
      </p>
      <p>
        <span class="title">Game: </span> {{broadcaster.game}}
      </p>
      <p>
        <span class="title">Title: </span> {{broadcaster.title}}
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Mplus',
  data() {
    return {
      datas: [],
      totalViewers: 0,
      totalStreamers: 0,
    };
  },
  beforeMount() {
    this.getUsers()
      .then((data) => {
        this.datas = data.sort((a, b) => b.view_count - a.view_count);

        this.totalViewers = data.reduce(
          (total, current) => total + parseInt(current.view_count, 10), 0,
        );
      });
    // .catch(() => console.log('Error'));
  },
  methods: {
    getUsers(cursor, data = []) {
      return axios.get(
        `https://api.twitch.tv/extensions/7wwefolylo2pmnnv61xlpjpm64y89k/live_activated_channels${(cursor ? '?cursor='.concat(cursor) : '')}`,
        { headers: { 'Client-Id': '7wwefolylo2pmnnv61xlpjpm64y89k' } },
      )
        .then((response) => {
          if (response.data.channels.length < 1) return data;
          data.push(...response.data.channels);
          return this.getUsers(response.data.cursor, data);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.mainmplus {
  display: grid;
  grid-template-columns: auto auto auto auto;
  grid-gap: 10px;
  color: #444655;
  padding: 10px;
  .titlebar {
    background-color: #A8AABC;
    padding: 20px;
    grid-column: 1 / span 4;
  }
  .item {
    background-color: #A8AABC;
    padding: 5px;
    grid-column: 1 / span 4;
    @media only screen and (min-width: 1000px) {
      grid-column: auto;
    }
    .name { font-size: 20px; }
  }
  p {
    line-height: 1.5;
  }
}
</style>
